/* @flow */

export const SELF = 'SELF';
